var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDialog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.0001 7.70078C14.7235 7.70078 7.20005 15.2233 7.20005 24.5008C7.20005 28.9556 8.93217 33.0026 11.7634 36.0121C12.2175 36.4949 12.1943 37.2543 11.7116 37.7084C11.2288 38.1625 10.4694 38.1393 10.0153 37.6566C6.78221 34.2198 4.80005 29.5909 4.80005 24.5008C4.80005 13.8978 13.3981 5.30078 24.0001 5.30078C34.602 5.30078 43.2001 13.8978 43.2001 24.5008C43.2001 35.1038 34.602 43.7008 24.0001 43.7008H6.00005C5.33731 43.7008 4.80005 43.1635 4.80005 42.5008C4.80005 41.838 5.33731 41.3008 6.00005 41.3008H24.0001C33.2766 41.3008 40.8001 33.7782 40.8001 24.5008C40.8001 15.2233 33.2766 7.70078 24.0001 7.70078Z",
    fill: "#15D4B6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9275 26.0795C24.8605 26.0795 25.6169 25.3232 25.6169 24.3902C25.6169 23.4571 24.8605 22.7008 23.9275 22.7008C22.9945 22.7008 22.2381 23.4571 22.2381 24.3902C22.2381 25.3232 22.9945 26.0795 23.9275 26.0795Z",
    fill: "#15D4B6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9275 26.0795C30.8605 26.0795 31.6169 25.3232 31.6169 24.3902C31.6169 23.4571 30.8605 22.7008 29.9275 22.7008C28.9945 22.7008 28.2381 23.4571 28.2381 24.3902C28.2381 25.3232 28.9945 26.0795 29.9275 26.0795Z",
    fill: "#15D4B6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9275 26.0795C18.8605 26.0795 19.6169 25.3232 19.6169 24.3902C19.6169 23.4571 18.8605 22.7008 17.9275 22.7008C16.9945 22.7008 16.2381 23.4571 16.2381 24.3902C16.2381 25.3232 16.9945 26.0795 17.9275 26.0795Z",
    fill: "#15D4B6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDialog);
export default __webpack_public_path__ + "static/media/iconDialog.660b2dacf1f80bf8c6b5245d67b97020.svg";
export { ForwardRef as ReactComponent };